(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9587],{

/***/ 81596:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topic/[hashTag]/[page]",
      function () {
        return __webpack_require__(42425);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 42425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _page_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/error/ErrorPage.tsx
var ErrorPage = __webpack_require__(55852);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/providers/hooks/useAuth.ts + 1 modules
var useAuth = __webpack_require__(79139);
// EXTERNAL MODULE: ./src/components/layout/Layout.tsx + 6 modules
var Layout = __webpack_require__(28146);
// EXTERNAL MODULE: ./src/page-components/topic/components/TopicHeaderV2.tsx
var TopicHeaderV2 = __webpack_require__(77277);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(63069);
// EXTERNAL MODULE: ./src/utils/normalizers/source.ts + 1 modules
var source = __webpack_require__(27079);
// EXTERNAL MODULE: ./src/page-components/topic/components/TopicContentNSI.tsx
var TopicContentNSI = __webpack_require__(15635);
// EXTERNAL MODULE: ./src/utils/metadata.utils.ts
var metadata_utils = __webpack_require__(83337);
// EXTERNAL MODULE: ./src/components/banner/GetTheAppBanner.tsx
var GetTheAppBanner = __webpack_require__(26202);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/navigation/NextLink.tsx
var NextLink = __webpack_require__(50752);
;// CONCATENATED MODULE: ./src/page-components/topic/PaginatedTopicPage.tsx













var PaginatedTopicPage = function(param) {
    var hashtagApi = param.hashtagApi;
    var isLoggedIn = (0,useAuth/* default */.Z)().isLoggedIn;
    var isMobileView = (0,esm.useIsMobileView)();
    var colorMode = (0,esm.useColorMode)().colorMode;
    var router = (0,next_router.useRouter)();
    var ref;
    var pageNumber = (ref = parseInt(router.query.page)) !== null && ref !== void 0 ? ref : 1;
    var numberOfPages = Math.ceil(hashtagApi.meta.total_count / 5.0);
    var hashtagUrlParam = router.query.hashTag;
    var renderPages = function() {
        var arr = [];
        var PAGES_MAX_NAVIGATION = isMobileView ? 1 : 3;
        if (pageNumber > PAGES_MAX_NAVIGATION + 1) {
            arr.push(1);
        }
        if (pageNumber > PAGES_MAX_NAVIGATION + 2) {
            arr.push(-1);
        }
        for(var i = Math.max(1, pageNumber - PAGES_MAX_NAVIGATION); i <= Math.min(pageNumber + PAGES_MAX_NAVIGATION, numberOfPages); i++){
            arr.push(i);
        }
        if (pageNumber < numberOfPages - PAGES_MAX_NAVIGATION - 1) {
            arr.push(-1);
        }
        if (pageNumber < numberOfPages - PAGES_MAX_NAVIGATION) {
            arr.push(numberOfPages);
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            maxW: "100%",
            alignSelf: "center",
            my: global/* GAP_SIZE_REM */.L3,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                    href: router.asPath === "/topic/[hashTag]/2" ? "/topic/[hashTag]" : "/topic/[hashTag]/[page]",
                    visibility: pageNumber > 1 ? "visible" : "hidden",
                    as: router.asPath === "/topic/[hashTag]/2" ? "/topic/".concat(hashtagUrlParam) : "/topic/[".concat(hashtagUrlParam, "]/").concat(pageNumber - 1),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Link, {
                        _hover: undefined,
                        _focus: undefined,
                        href: router.asPath === "/topic/[hashTag]/2" ? "/topic/".concat(hashtagUrlParam) : "/topic/".concat(hashtagUrlParam, "/").concat(pageNumber - 1),
                        color: esm.color[colorMode].text,
                        title: (pageNumber - 1).toString(),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                            transform: "rotate(180deg)",
                            _hover: {
                                cursor: "pointer"
                            },
                            px: esm.spacing.XS.rem,
                            py: esm.spacing.toRem(6),
                            mr: esm.spacing.XS.rem,
                            borderRadius: esm.spacing.L.rem,
                            align: "center",
                            justifyContent: "center",
                            color: esm.color[colorMode].textSecondary,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.CaretRightSvg, {})
                        })
                    })
                }),
                arr.map(function(element, index) {
                    return element === -1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        px: esm.spacing.M.rem,
                        py: esm.spacing.XS.rem,
                        mr: esm.spacing.XS.rem,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, {
                            color: esm.color[colorMode].text,
                            children: "..."
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                        href: element === 1 ? "/topic/[hashTag]" : "/topic/[hashTag]/[page]",
                        as: element === 1 ? "/topic/".concat(hashtagUrlParam) : "/topic/".concat(hashtagUrlParam, "/").concat(element),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                            borderRadius: esm.spacing.L.rem,
                            px: esm.spacing.M.rem,
                            py: esm.spacing.XS.rem,
                            mr: esm.spacing.XS.rem,
                            _hover: {
                                cursor: "pointer"
                            },
                            backgroundColor: element === pageNumber ? esm.color[colorMode].surface : esm.color[colorMode].top,
                            _active: undefined,
                            _focus: undefined,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Link, {
                                _hover: undefined,
                                _focus: undefined,
                                href: element === 1 ? "/topic/".concat(hashtagUrlParam) : "/topic/".concat(hashtagUrlParam, "/").concat(element),
                                color: esm.color[colorMode].text,
                                title: (element || "").toString(),
                                children: element
                            })
                        })
                    }, "pageIndex".concat(index));
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                    href: "/topic/[hashTag]/[page]",
                    visibility: pageNumber < numberOfPages ? "visible" : "hidden",
                    as: "/topic/".concat(hashtagUrlParam, "/").concat(pageNumber + 1),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Link, {
                        _hover: undefined,
                        _focus: undefined,
                        href: "/topic/".concat(hashtagUrlParam, "/").concat(pageNumber + 1),
                        color: esm.color[colorMode].text,
                        title: (pageNumber + 1).toString(),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                            px: esm.spacing.XS.rem,
                            py: esm.spacing.toRem(6),
                            mr: esm.spacing.XS.rem,
                            borderRadius: esm.spacing.L.rem,
                            align: "center",
                            justifyContent: "center",
                            color: esm.color[colorMode].textSecondary,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.CaretRightSvg, {})
                        })
                    })
                })
            ]
        });
    };
    var allIdeasSection = {
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TopicHeaderV2/* default */.Z, {
                    width: {
                        base: "100%",
                        md: (0,global/* getRemWidthFromColumns */._P)(8)
                    },
                    mb: global/* GAP_SIZE_REM */.L3,
                    hashtagSourcesApiResponse: hashtagApi,
                    pageNumber: router.query.page
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TopicContentNSI/* default */.Z, {
                    sources: hashtagApi.objects.map(function(apiSource) {
                        return (0,source/* normalizeSource */.Nr)(apiSource);
                    })
                }),
                renderPages()
            ]
        }),
        metaContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(GetTheAppBanner/* default */.Z, {}),
        metaContentTopOffset: 96,
        /**
     * If logged in sticky the top stashers and related topics subsections
     * If not logged in sticky the sign up card
     * This prop is only for the desktop view
     */ metaContentStickyOffset: isLoggedIn ? 32 : -688
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        pageMetadata: (0,metadata_utils/* getTopicPageMetadata */.$A)({
            topicTitle: hashtagApi.hashtag,
            topicName: hashtagApi.hashtag,
            pageCount: router.query.page,
            pageTitle: hashtagApi.seo_title,
            pageDescription: hashtagApi.seo_description
        }),
        isShortProAd: true,
        sections: [
            allIdeasSection
        ]
    });
};
/* harmony default export */ var topic_PaginatedTopicPage = (PaginatedTopicPage);

;// CONCATENATED MODULE: ./pages/topic/[hashTag]/[page].tsx




var TopicPaginatedDynamicPage = function(param) {
    var topicTag = param.topicTag, hashtagApi = param.hashtagApi;
    if (!topicTag || !hashtagApi) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* default */.Z, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(topic_PaginatedTopicPage, {
        topicTag: topicTag,
        hashtagApi: hashtagApi
    });
};
var __N_SSP = true;
/* harmony default export */ var _page_ = (TopicPaginatedDynamicPage);


/***/ }),

/***/ 94120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_page_components_landing_components_v2_LandingStartTrialSection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90182);







var SourceNSIArticleGradient = function(_param) {
    var collection = _param.collection, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "collection"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsMobileView)();
    // const router = useRouter();
    // We make the gradientFooterRef absolute after scrolling past a point.
    var gradientFooterRef = react__WEBPACK_IMPORTED_MODULE_2__.useRef(null);
    // const collectionSlug = React.useMemo(() => {
    //   if (collection === undefined) {
    //     return '';
    //   }
    //   return slugify(collection.name);
    // }, [collection]);
    // const collectionPageRoute = `/collection/${collection?.id}/${collectionSlug}`;
    // const minutesToRead = React.useMemo(() => {
    //   if (collection?.time_to_read !== undefined) {
    //     return formatSecondsToNearestMinute(collection.time_to_read);
    //   }
    //   return undefined;
    // }, [collection]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, {
        position: "absolute",
        ref: gradientFooterRef,
        height: "100%",
        width: "100%",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            // position={gradientFooterPosition === 'fixed' ? 'fixed' : 'absolute'}
            position: "absolute",
            zIndex: 5,
            bottom: 0,
            left: 0,
            top: "unset",
            right: 0,
            width: "100%",
            height: {
                base: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(480),
                md: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(600)
            },
            background: "linear-gradient(to top,  ".concat(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].background, " ").concat(isMobileView ? 75 : 60, "%,").concat(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.transparent, " 100%)"),
            flexDirection: "column",
            justifyContent: collection === undefined ? "flex-end" : "center",
            alignItems: "center",
            pb: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(8)
        }, props), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                px: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(16),
                flexDirection: "column",
                alignItems: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_page_components_landing_components_v2_LandingStartTrialSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    isCentered: true
                })
            })
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SourceNSIArticleGradient);


/***/ }),

/***/ 15635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var providers_hooks_useAuth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79139);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var src_components_banner_SignUpBanner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31072);
/* harmony import */ var src_components_metacontent_components_SubsectionHeader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17005);
/* harmony import */ var src_components_navigation_NextLink__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50752);
/* harmony import */ var src_components_source_source_collapsed_SourceCollapsed__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85611);
/* harmony import */ var src_page_components_source_components_SourceNSIArticleGradient__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94120);
/* harmony import */ var src_services_analytics__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62687);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(63069);
/* harmony import */ var utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(51599);












var TopicContentNSI = function(param) {
    var sources = param.sources;
    var isDesktopView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsDesktopView)();
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsMobileView)();
    var isLoggedIn = (0,providers_hooks_useAuth__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().isLoggedIn;
    var getHref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(source) {
        return "/article/".concat(source.id, "/").concat((0,utils_global__WEBPACK_IMPORTED_MODULE_10__/* .slugify */ .lV)(source.title));
    }, []);
    var onPreviewClick = function(source) {
        src_services_analytics__WEBPACK_IMPORTED_MODULE_9__/* .Analytics.logEvent */ .c.logEvent({
            eventName: src_services_analytics__WEBPACK_IMPORTED_MODULE_9__/* .Events.consumption.sourcePreviewClick */ .z.consumption.sourcePreviewClick,
            properties: {
                sourceId: source.id,
                element: "preview-idea",
                location: "hashtag-screen"
            },
            platforms: [
                "amplitude"
            ]
        });
    };
    var mainLayoutSectionHeight = !isMobileView ? deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(1400) : "unset";
    var renderItem = function(source, index) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, {
            onClick: function() {
                return onPreviewClick(source);
            },
            filter: index > 4 ? "blur(4px)" : "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_navigation_NextLink__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                href: getHref(source),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_source_source_collapsed_SourceCollapsed__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    source: source,
                    mb: utils_global__WEBPACK_IMPORTED_MODULE_10__/* .SQUARE_WIDTH_REM */ .wY
                }, source.id)
            })
        }, "topic-source-".concat(source.id, "-").concat(index));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, {
        pos: "relative",
        zIndex: 3,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, {
                height: mainLayoutSectionHeight,
                overflowY: "hidden",
                pos: "relative",
                zIndex: 3,
                children: [
                    !isLoggedIn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_page_components_source_components_SourceNSIArticleGradient__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_metacontent_components_SubsectionHeader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        children: utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_11__/* ["default"].allIdeas.toUpperCase */ .Z.allIdeas.toUpperCase()
                    }),
                    sources.map(function(source, index) {
                        return renderItem(source, index);
                    })
                ]
            }),
            !isLoggedIn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_banner_SignUpBanner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                size: isDesktopView ? "lg" : "sm",
                mt: isDesktopView ? utils_global__WEBPACK_IMPORTED_MODULE_10__/* .BLOCK_WIDTH_REM */ .sC : 0,
                mb: isDesktopView ? 0 : utils_global__WEBPACK_IMPORTED_MODULE_10__/* .SQUARE_WIDTH_REM */ .wY
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TopicContentNSI);


/***/ }),

/***/ 77277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_components_image_NextImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91260);
/* harmony import */ var utils_normalizers_hashtag__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51912);
/* harmony import */ var utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51599);
/* harmony import */ var utils_strings_pageStrings__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23244);
/* harmony import */ var utils_metatopics_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90031);











var TopicHeaderV2 = function(_param) {
    var hashtagSourcesApiResponse = _param.hashtagSourcesApiResponse, pageNumber = _param.pageNumber, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "hashtagSourcesApiResponse",
        "pageNumber"
    ]);
    var ref;
    var hashtagSources = (0,utils_normalizers_hashtag__WEBPACK_IMPORTED_MODULE_4__/* .normalizeHashtagSources */ .kq)(hashtagSourcesApiResponse);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsMobileView)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        if (isMobileView) return {
            titleStyle: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryHeadingFonts.small.bold,
            subTitleStyle: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.medium.regular
        };
        return {
            titleStyle: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryHeadingFonts.large.bold,
            subTitleStyle: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.medium.regular
        };
    }, [
        isMobileView
    ]), titleStyle = ref1.titleStyle, subTitleStyle = ref1.subTitleStyle;
    var headerImage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        // The topic names are different in METATOPICS, so we have to remove the spaces and switch to lower case
        var possibleImageUrls = utils_metatopics_constants__WEBPACK_IMPORTED_MODULE_7__/* .METATOPICS.filter */ .zY.filter(function(topic) {
            return topic.exploreId === "hashtag-".concat(hashtagSources.hashtag);
        }).map(function(topic) {
            return topic.image;
        });
        // We return a component only if we have a topic image
        if (possibleImageUrls.length > 0) {
            var imageUrl = possibleImageUrls[0];
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_image_NextImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                wrapperStyle: {
                    height: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(64),
                    minWidth: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(64),
                    mr: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem
                },
                imageUrl: imageUrl,
                alt: hashtagSources.hashtag,
                priority: true,
                isNotInteractable: true
            });
        }
        return null;
    }, [
        hashtagSources.hashtag
    ]);
    var ref2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
        width: "100%",
        align: "center",
        height: "100%"
    }, props), {
        children: [
            headerImage,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                flexDir: "column",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, titleStyle), {
                            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                            children: [
                                (ref2 = (ref = utils_metatopics_constants__WEBPACK_IMPORTED_MODULE_7__/* .UNSORTED_TOPICS */ .Ay[hashtagSources.hashtag]) === null || ref === void 0 ? void 0 : ref.title) !== null && ref2 !== void 0 ? ref2 : hashtagSources.hashtag,
                                pageNumber && " - Page ".concat(pageNumber)
                            ]
                        }))
                    }),
                    hashtagSources.totalIdeas && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, subTitleStyle), {
                        mr: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XXS.rem,
                        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                children: hashtagSources.totalIdeas
                            }),
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                children: utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_5__/* ["default"].ideas.toLowerCase */ .Z.ideas.toLowerCase()
                            }),
                            " ",
                            utils_strings_pageStrings__WEBPACK_IMPORTED_MODULE_6__/* ["default"].topic.header.onThisTopic */ .Z.topic.header.onThisTopic
                        ]
                    }))
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (TopicHeaderV2);


/***/ }),

/***/ 51912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aI": function() { return /* binding */ normalizeSearchedHashtag; },
/* harmony export */   "kq": function() { return /* binding */ normalizeHashtagSources; }
/* harmony export */ });
/* unused harmony export normalizeProfessionsWithHashtagsApiResponse */
/* harmony import */ var _source__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27079);
/* harmony import */ var _profile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7269);


var normalizeHashtagSources = function(hashtag) {
    var ref;
    var ref1;
    return {
        hashtag: hashtag.hashtag,
        meta: hashtag.meta,
        objects: hashtag.objects.map(function(src) {
            return (0,_source__WEBPACK_IMPORTED_MODULE_0__/* .normalizeSource */ .Nr)(src);
        }),
        totalIdeas: hashtag.total_ideas,
        relatedTopics: hashtag.related_hashtags,
        topStashers: (ref1 = (ref = hashtag.top_stashers) === null || ref === void 0 ? void 0 : ref.map(function(apiUser) {
            return (0,_profile__WEBPACK_IMPORTED_MODULE_1__/* .normalizeUserData */ .Te)(apiUser);
        })) !== null && ref1 !== void 0 ? ref1 : [],
        totalRelatedTopics: hashtag.total_related_hashtags,
        totalTopStashers: hashtag.total_top_stashers
    };
};
var normalizeSearchedHashtag = function(searchedHashtag) {
    var ref;
    return {
        sources: (ref = searchedHashtag.articles) === null || ref === void 0 ? void 0 : ref.map(function(article) {
            return (0,_source__WEBPACK_IMPORTED_MODULE_0__/* .normalizeSource */ .Nr)(article);
        }),
        name: searchedHashtag.name,
        totalIdeas: searchedHashtag.total_ideas
    };
};
var normalizeProfessionsWithHashtagsApiResponse = function(response) {
    var finalArray = [];
    response.departments.forEach(function(department) {
        finalArray.push({
            name: department.name,
            workHashtags: department.work_hashtags,
            personalHashtags: department.personal_hashtags,
            trendingHashtags: department.trending_hashtags
        });
    });
    return finalArray;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [296,7229,9000,9891,9834,5611,2853,3244,3299,9774,2888,179], function() { return __webpack_exec__(81596); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);